import { ChevronDownIcon, DebouncedTextField, Flex, Grid, Menu, Spacer, Text } from 'components'
import { startCase } from 'lodash-es'
import { useEffect, useState } from 'react'
import { IntegrationToolInfo, IntegrationType } from 'types'
import { useBreakpoint } from 'utils'
import { IntegrationCard, IntegrationConfiguration } from '../components'
import { integrationTools } from '../utils'

export default function IntegrationsPage() {
  const isMobile = useBreakpoint() < 2
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState<IntegrationFilter>('All')
  const [viewTools, setViewTools] = useState<IntegrationToolInfo[]>([])

  useEffect(() => {
    const tools = integrationTools
      .sort((a, b) => a.name.localeCompare(b.name))
      .filter(tool => {
        if (filter === 'All') return true
        return tool.type === filter
      })
      .filter(tool => {
        if (search === '') return true
        return tool.name.toLowerCase().includes(search.toLowerCase())
      })
    setViewTools(tools)
  }, [filter, search])

  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      p={isMobile ? 4 : 0}
      pb={3}
      pr={5}
      overflowY="auto"
      overflowX="hidden"
    >
      <Flex align="end" justify="space-between">
        <Flex direction="column">
          <Text textStyle="h3" pt={2}>
            Integrations
          </Text>
          <Text textStyle="h6">Connect your workspace with other services</Text>
        </Flex>
        <Spacer />
        <Flex gap={2}>
          <DebouncedTextField
            disabled={!integrationTools.length}
            onChange={setSearch}
            placeholder="Search..."
            value={search}
            controlled
          />
          <Menu
            disabled={!integrationTools.length}
            variant="solid"
            rightIcon={<ChevronDownIcon fontSize={'md'} />}
            gap={{ base: 0, sm: 2 }}
            buttonLabel={
              <Text textStyle="bodySmall" fontSize={{ base: '0', sm: 'sm' }}>
                Type: {startCase(filter) || 'All'}
              </Text>
            }
            menuProps={{ matchWidth: true }}
            value={filter}
            onChange={setFilter}
            options={filterOptions.map(value => ({ value }))}
          />
        </Flex>
      </Flex>

      <IntegrationConfiguration />
      <Grid templateColumns={isMobile ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)'} gap={isMobile ? 2 : 6}>
        {viewTools.map(tool => {
          return (
            <IntegrationCard
              key={tool.name}
              type={tool.type}
              tool={tool.name}
              isDisabled={tool.type !== 'CRM'}
            />
          )
        })}
      </Grid>
    </Flex>
  )
}

type IntegrationFilter = 'All' | IntegrationType
const filterOptions: IntegrationFilter[] = ['All', 'CRM', 'ATS', 'Productivity', 'Automation']
